import { useRef, useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { KeyboardShortcuts } from '@/shared/constants/keyboardShortcuts';

const usePlayerHotkeys = (
  onPlayPause: (e: Event) => void,
  onJumpForwardOneSecond: (e: Event) => void,
  onJumpBackwardOneSecond: (e: Event) => void,
  onEditTime: (e: Event) => void,
  onFullscreenToggle: (e: Event) => void,
) => {
  // Use refs to store the latest callback versions without triggering re-initialization
  const onPlayPauseRef = useRef(onPlayPause);
  const onJumpForwardRef = useRef(onJumpForwardOneSecond);
  const onJumpBackwardRef = useRef(onJumpBackwardOneSecond);
  const onEditTimeRef = useRef(onEditTime);
  const onFullscreenToggleRef = useRef(onFullscreenToggle);

  // Update refs when callbacks change
  useEffect(() => {
    onPlayPauseRef.current = onPlayPause;
    onJumpForwardRef.current = onJumpForwardOneSecond;
    onJumpBackwardRef.current = onJumpBackwardOneSecond;
    onEditTimeRef.current = onEditTime;
    onFullscreenToggleRef.current = onFullscreenToggle;
  }, [onPlayPause, onJumpForwardOneSecond, onJumpBackwardOneSecond, onEditTime, onFullscreenToggle]);

  // Log only once on mount
  useEffect(() => {
  }, []);

  const hotkeyOptions = {
    enableOnFormTags: false,
    enableOnContentEditable: false,
    preventDefault: true
  };

  // Register hotkeys with stable callbacks using refs
  useHotkeys(
    KeyboardShortcuts.PlayPause.hotkey,
    (e) => {
      e.preventDefault();
      onPlayPauseRef.current(e);
    },
    hotkeyOptions,
  );
  useHotkeys(
    KeyboardShortcuts.ShuttleForward.hotkey,
    (e) => {
      e.preventDefault();
      onJumpForwardRef.current(e);
    },
    hotkeyOptions,
  );
  useHotkeys(
    KeyboardShortcuts.ShuttleBackward.hotkey,
    (e) => {
      e.preventDefault();
      onJumpBackwardRef.current(e);
    },
    hotkeyOptions,
  );
  useHotkeys(
    KeyboardShortcuts.EditTime.hotkey,
    (e: KeyboardEvent) => {
      e.preventDefault();
      onEditTimeRef.current(e);
    },
    hotkeyOptions,
  );
  useHotkeys(
    KeyboardShortcuts.Fullscreen.hotkey,
    (e) => {
      e.preventDefault();
      onFullscreenToggleRef.current(e);
    },
    hotkeyOptions,
  );
 /* useHotkeys(
    KeyboardShortcuts.MoveFrameForward.hotkey,
    (e) => {
      e.preventDefault();
      onJumpForwardOneFrame(e);
    },
    [onJumpForwardOneFrame],
  );
  useHotkeys(
    KeyboardShortcuts.MoveFrameBackward.hotkey,
    (e) => {
      e.preventDefault();
      onJumpBackwardOneFrame(e);
    },
    [onJumpBackwardOneFrame],
  );*/
};

export default usePlayerHotkeys;
